import Attendee from "./Attendee";

class User {
    name;
    email;
    password;
    phone_number;
    attendees;

    constructor(values = {name: '', email: '', password: '', phone_number: ''}) {
        this.name = values.name;
        this.email = values.email;
        this.password = values.password;
        this.phone_number = values.phone_number;
    }

    static fromJSON(json) {
        let user = new User();
        user.name = json.name ?? "";
        user.email = json.email ?? "";
        user.password = json.password ?? "";
        user.phone_number = json.phone_number ?? "";
        user.attendees = json.attendees !== null ? json.attendees.map((attendee) => Attendee.fromJSON(attendee)) : [];

        return user;
    }
}

export default User;